/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'campaign': {
    width: 16,
    height: 16,
    viewBox: '0 0 16.64 16.64',
    data: `<path pid="0" d="M16.17 8a1.7 1.7 0 0 1 0 2.34l-5.86 5.86a1.7 1.7 0 0 1-2.34 0L.47 8.67A1.59 1.59 0 0 1 0 7.5V1.64A1.6 1.6 0 0 1 1.64 0H7.5a1.59 1.59 0 0 1 1.17.47zM2.89 4.14a1.22 1.22 0 0 0 .9-.35 1.19 1.19 0 0 0 .35-.88 1.2 1.2 0 0 0-1.23-1.23 1.2 1.2 0 0 0-1.23 1.23 1.19 1.19 0 0 0 .32.88 1.17 1.17 0 0 0 .89.35zM9.14 15L15 9.14 7.89 2.07 2.07 7.89z"/>`
  }
})



// WEBPACK FOOTER //
// ./src/icons/campaign.js